import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import Slider from 'react-slick';
import { pageBlockPropType } from '../../../propType/CustomPagePropType';
import CustomPageTopCarouselDescription from './CustomPageTopCarouselDescription';

const CustomPageTopCarousel = (props) => {

  let {
    pageBlock = {},
    pageTypeId
  } = props;

  let {
    pageBlockItems = [],
  } = pageBlock;

  let settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // arrows: true,
    adaptiveHeight: pageTypeId == 6 ? true : false,
    autoplay: true,
  };

  const renderKeyVisualBoxFixedHeight = (pageBlockItems = []) => {
    return pageBlockItems.map((pageBlockItem, index) => {
      let hasLink = pageBlockItem.itemUrl && pageBlockItem.itemUrl.length > 0;
      return (
        <div key={index}>
          <div className="d-flex justify-content-center align-items-center keyvisual-item">
            <div style={{
              backgroundImage: `url(${pageBlockItem.itemImageUrl})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              width: "100%",
              height: "100%",
              zIndex: 1
            }}></div>
            {!hasLink &&
              <React.Fragment>
                <h1 className="head" style={{
                                          fontWeight: "bold",
                                          margin: "0 0 2rem",
                                          position: "absolute",
                                          top: "50%",
                                          left: "50%",
                                          transform: "translate(-50%, -50%)",
                                          color: "#fff",
                                          textShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
                                          zIndex: 2
                                        }}>{pageBlockItem.itemName}</h1>
                <p className="subText" style={{marginBottom:"0",position:"absolute",top:"60%",left:"50%",transform:"translate(-50%, -50%)",color:"#fff",zIndex: 2, textShadow: "0 0 5px rgba(0, 0, 0, 0.3)"}}>{pageBlockItem.itemDescription}</p>
              </React.Fragment>
            }
            {hasLink &&
              <a href={pageBlockItem.itemUrl} target={pageBlockItem.itemOpenLinkType === 'OPEN_OTHER_WINOW'?'_blank':'_self'}>
                <h1 className="head" style={{
                                          fontWeight: "bold",
                                          margin: "0 0 2rem",
                                          position: "absolute",
                                          top: "50%",
                                          left: "50%",
                                          transform: "translate(-50%, -50%)",
                                          color: "#fff",
                                          textShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
                                          zIndex: 2
                                        }}>{pageBlockItem.itemName}</h1>
                <p className="subText" style={{marginBottom:"0",position:"absolute",top:"60%",left:"50%",transform:"translate(-50%, -50%)",color:"#fff",zIndex: 2, textShadow: "0 0 5px rgba(0, 0, 0, 0.3)"}}>{pageBlockItem.itemDescription}</p>
              </a>
            }

            {/*{ pageBlockItem.panelContents != null &&*/}
            {/*  <div className="caption text-white text-center inner" dangerouslySetInnerHTML={{__html: panel.panelContents}} ></div>*/}
            {/*}*/}
          </div>
        </div>
      );
    });
  };

  const renderKeyVisualBoxAdaptiveHeight = (pageBlockItems = []) => {
    return pageBlockItems.map((pageBlockItem, index) => {
      let hasLink = pageBlockItem.itemUrl && pageBlockItem.itemUrl.length > 0;
      return (
        <div key={index}>
          <div className="d-flex justify-content-center align-items-center keyvisual-item">
            {!hasLink &&
              <React.Fragment>
                <h1 className="head" style={{
                                          fontWeight: "bold",
                                          margin: "0 0 2rem",
                                          position: "absolute",
                                          top: "50%",
                                          left: "50%",
                                          transform: "translate(-50%, -50%)",
                                          color: "#fff"
                                        }}>{pageBlockItem.itemName}</h1>
                <p className="subText" style={{marginBottom:"0",position:"absolute",top:"60%",left:"50%",transform:"translate(-50%, -50%)",color:"#fff"}}>{pageBlockItem.itemDescription}</p>
                <img src={pageBlockItem.itemImageUrl} className="img-fluid" style={{width: "100%"}}/>
              </React.Fragment>
            }
            {hasLink &&
              <a href={pageBlockItem.itemUrl} target={pageBlockItem.itemOpenLinkType === 'OPEN_OTHER_WINOW'?'_blank':'_self'}>
                <h1 class="head" style={{
                                          fontWeight: "bold",
                                          margin: "0 0 2rem",
                                          position: "absolute",
                                          top: "50%",
                                          left: "50%",
                                          transform: "translate(-50%, -50%)",
                                          color: "#fff"
                                        }}>{pageBlockItem.itemName}</h1>
                <p className="subText" style={{marginBottom:"0",position:"absolute",top:"60%",left:"50%",transform:"translate(-50%, -50%)",color:"#fff"}}>{pageBlockItem.itemDescription}</p>
                <img src={pageBlockItem.itemImageUrl} className="img-fluid" style={{width: "100%"}}/>
              </a>
            }

            {/*{ pageBlockItem.panelContents != null &&*/}
            {/*  <div className="caption text-white text-center inner" dangerouslySetInnerHTML={{__html: panel.panelContents}} ></div>*/}
            {/*}*/}
          </div>
        </div>
      );
    });
  };

  return (
    <div>
      <div id="cp-carousel" className={'CustomPageKeyVisual TopCarousel'}>
        <Slider {...settings} >
          { pageTypeId === '6' ? renderKeyVisualBoxAdaptiveHeight(pageBlockItems) : renderKeyVisualBoxFixedHeight(pageBlockItems)}
        </Slider>
        <CustomPageTopCarouselDescription pageBlock={pageBlock} key={pageBlock.pageBlockId} pageTypeId={pageTypeId}/>
      </div>
    </div>
  );

};

CustomPageTopCarousel.fragments = {
  keyVisualBlock: gql`
      fragment CustomPageKeyVisual_keyVisualBlock on CustomPageKeyVisualBlockCacheResponseSchemaType {
          keyVisualType
          keyVisualPanels {
              panelImageUrl
              panelLinkUrl
              panelContents
          }
      }
  `,
};

CustomPageTopCarousel.propTypes = {
  pageBlock: pageBlockPropType(),
  pageTypeId: PropTypes.string.isRequired,
};

export default CustomPageTopCarousel;
